import React from 'react'

import Radio from '@mui/material/Radio';
import Grid from '@mui/material/Grid';

import IfElseEditor from "./ifelseEditor";
import IfEditor from "./ifEditor";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

const Row = ({ content, id, selected, onSelection, parentIndex, sectionName }) => {
    function handleSelectionChange(event) {
        onSelection(event.target.value);
    }

    function onRowClick(event) {
        event.stopPropagation();
        handleRowClick(id);
    }

    function handleRowClick(id) {
        onSelection(id);
    }

    if (content.type === "image") {
        return (<Grid container alignItems="center" style={{cursor: "pointer"}} onClick={onRowClick}>
            <Grid item style={{flexShrink: 0}}>
                <Radio
                    id={id}
                    value={id}
                    name="radio-button-demo"
                    checked={selected}
                    onChange={handleSelectionChange}
                    color="secondary"
                />
            </Grid>
            <Grid item xs style={{textAlign: content.align, minWidth: 0, overflow: "hidden"}}>
                <img {...content.config} style={{maxWidth: "100%", height: "auto"}} />
            </Grid>
        </Grid>);
    } else if (content.type === "text") {
        return (
            <Grid container alignItems="center" style={{cursor: "pointer"}} onClick={onRowClick}>
                <Grid item style={{flexShrink: 0}}>
                    <Radio
                        value={id}
                        name="radio-button-demo"
                        checked={selected}
                        onChange={handleSelectionChange}
                        color="secondary"
                    />
                </Grid>
                <Grid item xs style={{textAlign: content.align, minWidth: 0, overflow: "hidden"}} >
                    <div dangerouslySetInnerHTML={{__html: sanitizeHtml(content.config.text)}}></div>
                </Grid>
            </Grid>);
        ;
    } else if (content.type === "ifelse") {
        return (
            <Grid container alignItems="center" style={{cursor: "pointer"}} onClick={onRowClick}>
                <Grid item>
                    <Radio
                        value={id}
                        name="radio-button-demo"
                        checked={selected}
                        onChange={handleSelectionChange}
                        color="secondary"
                    />
                </Grid>
                <Grid item>
                    <IfElseEditor parentRowId={id} content={content} sectionName={sectionName} parentIndex={parentIndex} />
                </Grid>
            </Grid>);
    } else if (content.type === "if") {
        return (
            <Grid container alignItems="center" style={{cursor: "pointer"}} onClick={onRowClick}>
                <Grid item>
                    <Radio
                        value={id}
                        name="radio-button-demo"
                        checked={selected}
                        onChange={handleSelectionChange}
                        color="secondary"
                    />
                </Grid>
                <Grid item>
                    <IfEditor parentRowId={id} content={content} sectionName={sectionName} parentIndex={parentIndex} />
                </Grid>
            </Grid>);
    } else if (content.type === "mjml") {
        return (
            <Grid container alignItems="center" style={{cursor: "pointer"}} onClick={onRowClick}>
                <Grid item style={{flexShrink: 0}}>
                    <Radio
                        value={id}
                        name="radio-button-demo"
                        checked={selected}
                        onChange={handleSelectionChange}
                        color="secondary"
                    />
                </Grid>
                <Grid item xs style={{minWidth: 0, overflow: "hidden"}}>
                    {content.config.html
                        ? <div dangerouslySetInnerHTML={{__html: sanitizeHtml(content.config.html)}} style={{maxWidth: '100%', overflow: 'hidden', pointerEvents: 'none'}} />
                        : <div style={{fontFamily: 'monospace', fontSize: 12, color: '#999', padding: '4px 8px'}}>Empty MJML block — edit in Properties panel</div>
                    }
                </Grid>
            </Grid>);
    } else {
        return <span>Unknown type</span>;
    }
}

export default Row;